import { render } from "./IconVideo.vue?vue&type=template&id=17629b3f"
import script from "./IconVideo.vue?vue&type=script&lang=js"
export * from "./IconVideo.vue?vue&type=script&lang=js"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__